<template>
  <div class="hotelCommentBox">
    <dl class="hotelCommentBoxItem flexLeft">
      <dt>評価点（平均）</dt>
      <dd class="fontNo">
        <span>{{ averageRating }}</span> / 5
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'TkHotelReviewCommon',
  components: {},
  props: {
    averageRating: { type: String, default: '0.0' },
  },
}
</script>

<style lang="scss" scoped>
@import '~@ota-frontend/ui/src/scss/components/TkHotelReview.scss';
</style>
